<script setup lang="ts">
import { onBeforeMount } from 'vue';

onBeforeMount(async () => {
    console.log('[Dashboard MFE] mounted');
});
</script>

<template>
    <div class="mfe-container">
        <router-view />
    </div>
</template>

<style lang="scss" scoped>
// Global (non-scoped) — sets font for the entire MFE
@use 'certifid-v2-client-hub-styles' as *;

.mfe-container {
    height: 100%;
    font-family: $family-sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;

    & > * {
        height: 100%;
    }
}
</style>
